import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import {
  ApiErrorResponse,
  ApiOnboardingSurveyRequestBody,
  ApiOnboardingSurveyResponse,
} from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { AxiosResponse } from 'axios'
import { getRandomExampleHeader } from '@app/api/utils/mock'

type PostUserSurveyParams = {
  requestBody: ApiOnboardingSurveyRequestBody
}

const postUserSurvey = async ({
  requestBody,
}: PostUserSurveyParams): Promise<ApiOnboardingSurveyResponse> => {
  const apiResponse: AxiosResponse<ApiOnboardingSurveyResponse> =
    await apiAuthClient.post(endpoints.postUserSurvey, requestBody, {
      headers: {
        ...getRandomExampleHeader(['example-1']),
      },
    })

  return apiResponse.data
}

export const useUserSurvey = () =>
  useMutation<
    ApiOnboardingSurveyResponse,
    ApiErrorResponse,
    PostUserSurveyParams
  >(postUserSurvey)
